import type * as api from '@gitbook/api-client';
import { type Document, type DocumentJSON, deserialize, serialize } from '@gitbook/slate';

/**
 * Encode a document value as JSON.
 */
export function encodeDocumentForAPI(document: Document): api.JSONDocument {
    // @ts-ignore
    return serialize(document);
}

/**
 * Decode a document value from JSON.
 */
export function decodeDocumentFromAPI(document: api.JSONDocument): Document {
    return deserialize(document as DocumentJSON);
}
